import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonBase } from "@mui/material";
import { Checkbox, Divider, message, Row } from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { calculadoras } from "./items";
import { errorMessage } from "../../../utils";
import { CalculadorasSelectContainer } from "./styles";
import { useAuth } from "../../../contexts/AuthContext";

export const CalculadorasSelect = () => {
  const navigate = useNavigate();
  const { handleCalcs, loading, user } = useAuth();
  const userCalcs = user?.user?.visibleCalcs?.filter((calc) =>
    calculadoras.find((c) => c.id === calc)
  );
  const hasCalcs = userCalcs && userCalcs.length > 0;

  const [calcs, setCalcs] = useState<string[]>(
    hasCalcs ? userCalcs : [calculadoras[0].id]
  );

  const handleSelect = (id: string) => {
    if (calcs.includes(id)) {
      setCalcs((calcs) => calcs.filter((item) => item !== id));
    } else {
      setCalcs((calcs) => [...calcs, id]);
    }
  };

  const handleNext = async () => {
    if (loading) {
      return;
    }
    if (calcs.length === 0) {
      return message.warning("Você deve selecionar ao menos uma calculadora");
    }
    try {
      await handleCalcs({ calcs });
    } catch (err) {
      message.error(errorMessage);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <CalculadorasSelectContainer>
      <div className="calculadoras">
        {calculadoras.map((item) => (
          <ButtonBase>
            <Checkbox
              key={item.id}
              checked={calcs.includes(item.id)}
              onChange={() => handleSelect(item.id)}
            >
              <div className="checkbox-wrapper">
                {item.icon}
                <div className="label">{item.name}</div>
              </div>
            </Checkbox>
          </ButtonBase>
        ))}
      </div>
      <Divider />
      <Row justify={hasCalcs ? "space-between" : "end"}>
        {hasCalcs && (
          <Button
            size="large"
            color="inherit"
            variant="contained"
            onClick={handleCancel}
          >
            Cancelar
          </Button>
        )}
        <Button
          size="large"
          color="secondary"
          variant="contained"
          onClick={handleNext}
          startIcon={loading && <LoadingOutlined />}
          endIcon={<ArrowRightOutlined />}
        >
          Continuar
        </Button>
      </Row>
    </CalculadorasSelectContainer>
  );
};
